import { useSearchParams } from 'react-router-dom';
import { Users, Mic2, Theater } from 'lucide-react';
import { PageTitle } from '../ui';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import SuiviClients from './SuiviClients';
import SuiviArtistes from './SuiviArtistes';
import SuiviDomaines from './SuiviDomaines';

export default function AnnuaireAnalytique() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab');
  const tab = raw === 'artistes' || raw === 'domaines' ? raw : 'clients';

  return (
    <div>
      <PageTitle
        title="Annuaire analytique"
        subtitle="Activité et historique par client, artiste ou domaine"
        icon={<Users className="text-amber-400" size={24} strokeWidth={1.5} />}
      />

      <Tabs
        value={tab}
        onValueChange={(v) => {
          const next = new URLSearchParams(params);
          next.set('tab', v);
          setParams(next, { replace: true });
        }}
        className="w-full"
      >
        <TabsList className="bg-slate-900 border border-slate-800">
          <TabsTrigger value="clients" className="data-[state=active]:bg-amber-500/10 data-[state=active]:text-amber-300">
            <Users size={14} strokeWidth={1.5} className="mr-2" /> Clients
          </TabsTrigger>
          <TabsTrigger value="artistes" className="data-[state=active]:bg-amber-500/10 data-[state=active]:text-amber-300">
            <Mic2 size={14} strokeWidth={1.5} className="mr-2" /> Artistes
          </TabsTrigger>
          <TabsTrigger value="domaines" className="data-[state=active]:bg-amber-500/10 data-[state=active]:text-amber-300">
            <Theater size={14} strokeWidth={1.5} className="mr-2" /> Domaines
          </TabsTrigger>
        </TabsList>
        <TabsContent value="clients" className="mt-4">
          <SuiviClients embedded />
        </TabsContent>
        <TabsContent value="artistes" className="mt-4">
          <SuiviArtistes embedded />
        </TabsContent>
        <TabsContent value="domaines" className="mt-4">
          <SuiviDomaines embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
